module.exports = __webpack_public_path__ + "static/logo-dark-7d640b883ed26e86ea9529201b08f155.svg";